import type { GamePageTranslations } from "@casino/server/graphql/getCmsGamePagePhrases";

const translatePhrase = (
  translations: GamePageTranslations | undefined,
  key: string,
  fallback: string,
) => translations?.[key] ?? fallback;

export default translatePhrase;
